import Promise from 'bluebird';

/**
 * Append a <script> tag to the body so that it will be loaded.
 * @param {String} id - Unique identifier for this script.
 * @param {String} src - Source URL where the script will be loaded from.
 * @param {String} inlineCode - JS code to insert in the script tag.
 * @param {Object} logger - Instrumentation logger object
 * @param {Number} [timeout] - Timeout in milliseconds before throwing an exception. Timeout will
 * occur if script host is unavailable or a browser extension interferes with the network request.
 * @returns {Promise} - Resolves once the script has been loaded.
 */
export const loadScriptAsynchronously = ({
  id, src, inlineCode, logger, timeout = 5000,
}) =>
  new Promise((resolve) => {
    if (document.getElementById(id)) {
      logger.logTrace(`Found existing ${id} SDK script`);
      resolve();
    } else {
      const element = document.createElement('script');

      element.id = id;

      if (src) {
        element.src = src;
        element.onload = resolve;
      }

      if (inlineCode) {
        const scriptNode = document.createTextNode(inlineCode);

        element.appendChild(scriptNode);
        element.type = 'text/javascript';

        if (!src) {
          resolve();
        }
      }

      element.async = true;

      document.body.appendChild(element);

      logger.logTrace(`Insert ${id} SDK script`);
    }
  }).timeout(timeout, `Loading script timed out after ${timeout}ms.`);
